import { useAppDispatch,useAppSelector } from 'app/hooks';
import { AppSuiteTenant, License } from 'common/types/Entities';
import { useFetchLicensesProductEntitlements } from 'features/reports/hooks/useFetchLicensesProductEntitlements';
import { useFetchLicensesUsers } from 'features/reports/hooks/useFetchLicensesUsers';

import { selectIsReportModalOpen,setReportModalOpen } from '../../reportPrintingModalSlice';
import { ReportCustomTableColumn } from '../../typeDefs';
import { ReportModalContent } from '../common/ReportModalContent';
import { ReportPrintingModal } from '../common/ReportPrintingModal';

type LicensesReportContentProps = {
    licenses: License[];
    userLimit: string;
    userLimitDisabled: boolean;
    currentTenant: AppSuiteTenant;
}

const LICENSES_PRODUCT_ENTITLEMENTS_COLUMNS: ReportCustomTableColumn[] = [
    { id: 'principalName', label: 'Company Group/User', minWidth: 120, align: 'left' },
    { id: 'resourceName', label: 'Product Name', minWidth: 120, align: 'left' },
    { id: 'accessName', label: 'Access', minWidth: 120, align: 'left' },
    { id: 'licenseBillingRecord', label: 'Billing', minWidth: 120, align: 'left' },
    { id: 'startDate', label: 'Start date', minWidth: 120, align: 'left' },
    { id: 'endDate', label: 'End date', minWidth: 120, align: 'left' }
];



export const LicensesReportContent = ({
    licenses,
    userLimit,
    userLimitDisabled,
    currentTenant
}: LicensesReportContentProps) => {
    const { name: tenantName } = currentTenant;

    const dispatch = useAppDispatch();
    const modalIsOpen = useAppSelector(selectIsReportModalOpen);

    const licensesNames  = licenses.flatMap(license => license.billingSystemName + ' - ' + license.billingRecord);
    const {
        processing: processingProductEntitlementsFetch,
        productEntitlements
    } = useFetchLicensesProductEntitlements(licenses, currentTenant);
    const {
        processing: processingUsersFetch,
        users
    } = useFetchLicensesUsers(licenses, userLimit, userLimitDisabled);

    const handleCloseReportModal = () => {
        dispatch(setReportModalOpen(false));
    };

    return (
        <ReportPrintingModal
            title='OPIS Proof of Delivery'
            firstHeaderTitle='Licenses'
            firstHeaderValues={licensesNames}
            secondHeaderTitle='Product'
            secondHeaderValue={tenantName}
            open={modalIsOpen}
            onClose={handleCloseReportModal}
            processing={processingProductEntitlementsFetch || processingUsersFetch}
        >
            <ReportModalContent
                entitlementsColumns={LICENSES_PRODUCT_ENTITLEMENTS_COLUMNS}
                entitlementsRows={productEntitlements}
                usersRows={users}
                processingProductEntitlementsFetch={processingProductEntitlementsFetch}
                processingUsersFetch={processingUsersFetch}
            />
        </ReportPrintingModal>
    );
};
